export const iconFontAwesomeWeatherCloud = (
	<i className="fa-solid fa-cloud"></i>
);
